import React, { useEffect, useState } from "react";
import "./loginComponent.css";
import loginLogo from "../../assets/images/newLogo.png";
import ColorBtn from "../../commanComponents/buttons/ColorBtn";
import OTPInput from "react-otp-input";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useMutation } from "react-query";
import toast from "react-hot-toast";
import { communication } from "../../constants/apis/communication";
import Loader from "../../commanComponents/Loader";
import { Controller, useForm } from "react-hook-form";

export default function OtpScreen() {
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState(120);
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      otp: "",
    },
  });

  const { mutate, isLoading } = useMutation((data) => communication?.verifyOtp(data), {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (data?.data?.status == "SUCCESS") {
        toast.success(`Success: ${data?.data?.message}`);
        navigate(`/login?page=new-password&userId=${userId}`);
      } else {
        toast.error(`Failed : ${data?.data?.message}`);
      }
    },
    onError: (error) => {
      toast.error(`Failed to update status: ${error?.message}`);
    },
  });

  const { mutate: resendOtp, isLoading: resendOtpLoading } = useMutation((data) => communication?.resetPassword(data), {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (data?.data?.status == "SUCCESS") {
        toast.success(`Success (OTP:${data?.data?.otp}) : ${data?.data?.message}`);
        setTimeLeft(120);
      } else {
        toast.error(`Failed : ${data?.data?.message}`);
      }
    },
    onError: (error) => {
      toast.error(`Failed to update status: ${error?.message}`);
    },
  });

  const handleOtpVerification = (data) => {
    const dataToSend = {
      userId,
      otp: data?.otp,
    };

    mutate(dataToSend);
  };

  useEffect(() => {
    if (!timeLeft) {
      return;
    }
    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return (
    <>
      {(isLoading || resendOtpLoading) && <Loader />}
      <div className="loginComponent">
        <div className="loginLeft">
          <div className="logoContainer">
            <img src={loginLogo} alt="MOIL Logo" />
            <h1>MOIL LIMITED</h1>
            <p>( A Government of India Enterprise )</p>
          </div>
        </div>

        <div className="loginRight">
          <div className="loginFormContainer">
            <div className="centeredFormHeader">
              <h2>OTP Verification</h2>
              <p>
                <strong>Enter the code from the sms we sent</strong>
              </p>
            </div>

            <form className="d-flex flex-column gap-4" onSubmit={handleSubmit(handleOtpVerification)}>
              <div className="text-center" style={{ color: "#2F3299", fontWeight: "700", fontSize: "18px" }}>
                {minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}
              </div>

              <div
                className="otpInputWrapper"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Controller
                  name="otp"
                  control={control}
                  rules={{
                    required: "OTP is required",
                    minLength: {
                      value: 4,
                      message: "Please enter valid OTP",
                    },
                  }}
                  render={({ field }) => (
                    <OTPInput
                      value={field.value}
                      onChange={field.onChange}
                      numInputs={4}
                      renderInput={(props) => (
                        <input
                          {...props}
                          style={{
                            width: "50px",
                            height: "50px",
                            margin: "0 6px",
                            fontSize: "20px",
                            borderRadius: "8px",
                            border: errors?.otp ? "2px solid red" : "1px solid #c7c7c7",
                            outline: "none",
                            textAlign: "center",
                          }}
                        />
                      )}
                    />
                  )}
                />

                {errors?.otp && (
                  <p
                    style={{
                      color: "red",
                      fontSize: "13px",
                      marginTop: "8px",
                      fontWeight: "500",
                    }}
                  >
                    {errors?.otp?.message}
                  </p>
                )}
              </div>

              <div className="text-center" style={{ marginTop: "-5px" }}>
                <span style={{ color: "#555", fontSize: "14px", fontWeight: "600" }}>
                  I didn't receive any code.{" "}
                  <span
                    style={{ fontWeight: "700", color: timeLeft == 0 ? "#2F3299" : "#c7c7c7", cursor: timeLeft == 0 ? "pointer" : "default" }}
                    onClick={() => {
                      if (timeLeft === 0) resendOtp({ userId });
                    }}
                  >
                    RESEND
                  </span>
                </span>
              </div>

              <div className="formLinks">
                <p
                  onClick={() => {
                    navigate("/login?page=reset");
                  }}
                >
                  Back?
                </p>
              </div>

              <ColorBtn
                text={"Reset Password"}
                bgColor="#2F3299"
                color="#fff"
                style={{
                  boxShadow: "0px 4px 4px 0px #00000040",
                  border: "none",
                  width: "100%",
                  padding: "12px",
                  borderRadius: "6px",
                  fontSize: "16px",
                  fontWeight: "600",
                  marginTop: "10px",
                }}
              />
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
